export const withImageKitTransform = (url: string, transform: string): string => {
  try {
    const parsed = new URL(url);
    const existing = parsed.searchParams.get('tr');
    parsed.searchParams.set('tr', existing ? `${existing},${transform}` : transform);
    return parsed.toString();
  } catch {
    return '';
  }
};